import { supabase } from '../supabase.js';

const ALLOWED_AUTH_USER_IDS = ['b89e950a-c9e4-4425-b6e7-8ff30f31b517'];
const ALLOWED_EMAILS = [
  'jwentzien1967@gmail.com'
];

class AuthStore {
  user = $state(null);
  profile = $state(null);
  loading = $state(true);
  error = $state(null);

  get isAuthenticated() {
    return !!this.user;
  }

  get isAllowed() {
    if (!this.user) return false;
    if (ALLOWED_AUTH_USER_IDS.includes(this.user.id)) return true;
    const email = (this.user.email || '').toLowerCase();
    return ALLOWED_EMAILS.map(e => e.toLowerCase()).includes(email);
  }

  async init() {
    this.loading = true;
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.user) {
      this.user = session.user;
      await this.loadProfile();
    }
    supabase.auth.onAuthStateChange((_event, session) => {
      this.user = session?.user || null;
      if (this.user) this.loadProfile();
      else this.profile = null;
    });
    this.loading = false;
  }

  async loadProfile() {
    if (!this.user) return;
    const { data, error } = await supabase
      .from('blv_profiles')
      .select('id, username')
      .eq('auth_user_id', this.user.id)
      .single();
    if (error) {
      console.warn('Could not load profile:', error.message);
      return;
    }
    this.profile = data;
  }

  async signInWithGoogle() {
    this.error = null;
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin }
    });
    if (error) this.error = error.message;
  }

  async sendOtp(email) {
    this.error = null;
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.origin }
    });
    if (error) {
      this.error = error.message;
      return false;
    }
    return true;
  }

  async verifyOtp(email, token) {
    this.error = null;
    const { error } = await supabase.auth.verifyOtp({
      email,
      token,
      type: 'email'
    });
    if (error) {
      this.error = error.message;
      return false;
    }
    return true;
  }

  async signOut() {
    await supabase.auth.signOut();
    this.user = null;
    this.profile = null;
  }
}

export const auth = new AuthStore();
